import SelectField from 'components/forms/selectField/SelectField';
import { SelectFieldProps } from 'components/forms/selectField/SelectField.types';
import { AutomatedReviewLogStatus } from 'models/automation/Reviews';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'utils/arrayUtils';

interface StatusSelectFieldProps
  extends Omit<SelectFieldProps, 'options' | 'optionGroups'> {}

const StatusSelectField = ({ ...props }: StatusSelectFieldProps) => {
  const { t } = useTranslation();
  const statuses = Object.values(AutomatedReviewLogStatus).map((value) => ({
    label: t('pageAutomations.reviews.automatedReviewLogs.statuses.status', {
      context: value,
    }),
    value,
  }));
  const options = orderBy(statuses, [{ field: 'label', order: 'asc' }]);

  return (
    <SelectField
      colSmInput={8}
      colSmLabel={4}
      options={[{ label: t('common.all'), value: '' }, ...options]}
      {...props}
    />
  );
};

export default StatusSelectField;
